/* Ooser theme — theme.js
   Vanilla JS: drawers, cart (AJAX + Section Rendering API), product variant picker, gallery, recommendations. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- money ---------- */
  const moneyFormat = document.body.dataset.moneyFormat || '${{amount}}';
  function money(cents) {
    const n = cents / 100;
    const group = (s) => s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(String(Math.round(n))))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount\s*\}\}/g, group(n.toFixed(2)));
  }

  /* ---------- drawers ---------- */
  let lastFocus = null;
  function openDrawer(el) {
    if (!el || !el.hidden) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    void el.offsetHeight; // commit display before transition
    el.classList.add('is-open');
    document.body.classList.add('has-drawer');
    const f = el.querySelector('[data-drawer-close]');
    if (f) f.focus();
  }
  function closeDrawer(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.body.classList.remove('has-drawer');
    const done = () => { if (!el.classList.contains('is-open')) el.hidden = true; };
    el.addEventListener('transitionend', done, { once: true });
    setTimeout(done, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) { e.preventDefault(); openDrawer(target); }
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      const drawer = closer.closest('.drawer');
      if (drawer) { if (closer.tagName !== 'A') e.preventDefault(); closeDrawer(drawer); }
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });

  /* ---------- cart ---------- */
  function sectionIds() {
    const ids = ['header'];
    if ($('#CartDrawer')) ids.push('cart-drawer');
    const main = $('[data-cart-main]');
    if (main && main.dataset.sectionId) ids.push(main.dataset.sectionId);
    return ids;
  }
  function swap(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const src = doc.querySelector(selector);
    const dst = $(selector);
    if (src && dst) dst.replaceWith(src);
  }
  function renderSections(sections) {
    if (!sections) return;
    if (sections.header) swap(sections.header, '#CartBubble');
    if (sections['cart-drawer']) swap(sections['cart-drawer'], '#CartDrawerInner');
    const main = $('[data-cart-main]');
    if (main && sections[main.dataset.sectionId]) swap(sections[main.dataset.sectionId], '[data-cart-main]');
  }
  async function cartChange(line, quantity) {
    const body = { line: String(line), quantity, sections: sectionIds().join(','), sections_url: location.pathname };
    const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await r.json();
    if (data.sections) renderSections(data.sections);
    return data;
  }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-cart-change]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    try { await cartChange(b.dataset.line, parseInt(b.dataset.cartChange, 10)); }
    catch (err) { b.disabled = false; }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches || !form.matches('form[data-product-form]')) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add]');
    const err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    const fd = new FormData(form);
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', location.pathname);
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      const data = await r.json();
      if (data.status) {
        if (err) { err.textContent = data.description || data.message || form.dataset.errorText; err.hidden = false; }
      } else {
        renderSections(data.sections);
        const drawer = $('#CartDrawer');
        if (drawer) openDrawer(drawer); else location.href = '/cart';
      }
    } catch (x) {
      if (err) { err.textContent = form.dataset.errorText || 'Could not add to bag. Try again.'; err.hidden = false; }
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    }
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const wrap = b.closest('.qty');
    const input = wrap && wrap.querySelector('input');
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    const next = parseInt(input.value || String(min), 10) + (b.dataset.qty === '+' ? 1 : -1);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product: gallery + variants ---------- */
  function warmImg(img) { if (img && img.loading === 'lazy') img.loading = 'eager'; }
  function showMedia(root, id) {
    $$('.gallery__slide', root).forEach((s) => {
      const on = String(s.dataset.mediaId) === String(id);
      if (on) warmImg(s.querySelector('img'));
      s.classList.toggle('is-active', on);
    });
    $$('.gallery__thumb', root).forEach((t) => t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)));
  }
  // Hidden slides never lazy-load (display:none never intersects), so warm them once the page is idle.
  window.addEventListener('load', () => {
    const warm = () => $$('.gallery__slide img, .gallery__thumb img').forEach(warmImg);
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1500);
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    showMedia(t.closest('[data-product]') || document, t.dataset.thumb);
  });

  $$('[data-product]').forEach((root) => {
    const dataEl = root.querySelector('[data-variants]');
    const form = root.querySelector('form[data-product-form]');
    if (!dataEl || !form) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (x) { return; }
    const idInput = form.querySelector('[data-variant-id]');
    const addBtn = form.querySelector('[data-add]');
    const addLabel = form.querySelector('[data-add-label]');
    const priceWrap = root.querySelector('[data-price-wrap]');
    const fieldsets = $$('[data-option-index]', root);
    const t = { add: root.dataset.textAdd || 'Add to bag', soldOut: root.dataset.textSoldOut || 'Sold out', unavailable: root.dataset.textUnavailable || 'Unavailable' };
    if (!fieldsets.length) return;

    const selected = () => fieldsets.map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
    const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));

    function markAvailability(opts) {
      fieldsets.forEach((fs, i) => {
        $$('input[data-option-input]', fs).forEach((input) => {
          const ok = variants.some((v) => v.available && v.options[i] === input.value && v.options.every((o, k) => k === i || opts[k] == null || o === opts[k]));
          const label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function render() {
      const opts = selected();
      fieldsets.forEach((fs, i) => { const l = fs.querySelector('[data-option-label]'); if (l) l.textContent = opts[i] ? '— ' + opts[i] : ''; });
      markAvailability(opts);
      const v = findVariant(opts);
      if (!v) { if (addBtn) addBtn.disabled = true; if (addLabel) addLabel.textContent = t.unavailable; return; }
      if (idInput) idInput.value = v.id;
      if (priceWrap) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        priceWrap.innerHTML = '<span class="price' + (sale ? ' price--sale' : '') + '"><span class="price__now">' + money(v.price) + '</span>' + (sale ? '<s class="price__was">' + money(v.compare_at_price) + '</s>' : '') + '</span>';
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? t.add + ' — ' + money(v.price) : t.soldOut;
      if (v.featured_media && v.featured_media.id) showMedia(root, v.featured_media.id);
      if (window.history && history.replaceState) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      }
    }
    root.addEventListener('change', (e) => { if (e.target.matches('[data-option-input]')) render(); });
    markAvailability(selected());
  });

  /* ---------- recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (!el.dataset.url) return;
    try {
      const r = await fetch(el.dataset.url);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    } catch (x) { /* leave empty */ }
  });

  /* ---------- collection sort ---------- */
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-sort]');
    if (!s) return;
    const u = new URL(location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* ---------- theme editor: reopen drawer when its section is selected ---------- */
  document.addEventListener('shopify:section:select', (e) => {
    const d = e.target && e.target.querySelector && e.target.querySelector('#CartDrawer');
    if (d) openDrawer(d);
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const d = e.target && e.target.querySelector && e.target.querySelector('#CartDrawer');
    if (d) closeDrawer(d);
  });
})();
